<template>
    <tile link="ved">
        <div slot="tileHeader">
            <tile-title icon="globe">Внешнеэкономическая деятельность</tile-title>
        </div>
        <div class="ved" v-if="years.length" slot="tileContent">
            <div ref="vedHtml">
                <table class="ved__table">
                    <thead>
                        <tr>
                            <th class="first-column"></th>
                            <th>Контракто-<br>держатель</th>
                            <th>Декларант</th>
                            <th>Получатель</th>
                            <th>Отправитель</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(e, i) in years" :key="i">
                            <td class="first-column">{{ e }}</td>
                            <td>
                                <checkOrTimes v-if="auth" :isCheck="data[e].holder" />
                                <span v-else>░░</span>
                            </td>
                            <td>
                                <checkOrTimes v-if="auth" :isCheck="data[e].declarant" />
                                <span v-else>░░</span>
                            </td>
                            <td>
                                <checkOrTimes v-if="auth" :isCheck="data[e].receiver" />
                                <span v-else>░░</span>
                            </td>
                            <td>
                                <checkOrTimes v-if="auth" :isCheck="data[e].sender" />
                                <span v-else>░░</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="ved__footer" slot="tileFooter">
            <tilePrintPdf 
                :html="htmlForPrint"
                :title="title"
                :filename="filename" 
                :printStyle="printStyle"
            />
        </div>
    </tile>
</template>

<script>
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import checkOrTimes from '@/components/card/ved/checkOrTimes.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import tile from '@/components/ui/tile/tile.vue'
import { demoEncode } from '@/helpers.ts'

export default {
    components: {
        tileTitle,
        checkOrTimes,
        tilePrintPdf,
        tile
    },
    data() {
        return {
            htmlForPrint: '',
            printStyle: `
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
                }
                .uk-icon-check:before {
                    content: "✓";
    	            color: #33b169;
                    font-size: 24px;
                    font-family: Lucida Sans Unicode;
                }
                .uk-icon-times:before {
                    content: "x";
		            color: #e74c3c;
                    font-size: 24px;
                    font-family: Lucida Sans Unicode;
                }
            `
        }
    },
    computed: {
        data() { return this.$store.state.card?.company?.ved },
        years() { return this.data ? Object.keys(this.data).reverse() : [] },
        name_short() { return this.$store.state?.card?.company?.name_short },
        name_full() { return this.$store.state?.card?.company?.name_full },
        ogrn() { return this.$store.state?.card?.company?.ogrn },
        title() { return `Внешнеэкономическая деятельность | ${this.name_short || this.name_full}` },
        filename() { return `ved_${this.ogrn}` }
    },
    mounted() {
        if(!this.data) {
            document.getElementById('ved-tile').style.display = 'none'
        } else {
            this.htmlForPrint = this.$refs?.vedHtml?.innerHTML
        }
    }
}
</script>
<style lang="sass" scoped>
@import '../../../../styles/global-variables'

.ved
    &__table
        @include lic-table()
        .first-column
            width: 1%
            text-align: left
            font-weight: 600
            font-size: 14px
    &__footer
        width: 100%
        display: flex
        justify-content: flex-end
        align-items: center        
                
</style>